module.exports = __webpack_public_path__ + "img/calendar.911746aa.svg";